import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { useParams } from 'react-router-dom';
import {
  PhoneIcon,
  WhatsAppIcon,
  EmailIcon,
  ArrowUpIcon,
} from '../icons';
import css from './ContactHelp.module.css';

const PHONE_NUMBER = '+4915730977660';
const PHONE_DISPLAY = '+49 157 30 97 76 60';
const WHATSAPP_LINK = 'https://wa.me/4915730977660';
const EMAIL = 'booking@socialbnb.de';
const ALEX_AVATAR_MOBILE =
  'https://res.cloudinary.com/dlcacck3a/image/upload/w_92,h_92,c_fill,g_face,q_auto:best,f_auto/v1769083002/socialbnb/containers/OldSTLandingPage/sections/QuickMenu/images/01_Alex_wide.webp';
const ALEX_AVATAR_DESKTOP =
  'https://res.cloudinary.com/dlcacck3a/image/upload/w_108,h_108,c_fill,g_face,q_auto:best,f_auto/v1769083002/socialbnb/containers/OldSTLandingPage/sections/QuickMenu/images/01_Alex_wide.webp';

const TRUSTPILOT_RATING =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082891/socialbnb/components/Footer/components/assets/main/trustpilotRating.webp';
const NATGEO_LOGO =
  'https://res.cloudinary.com/dlcacck3a/image/upload/e_negate/v1769082965/socialbnb/containers/OldSTLandingPage/sections/HeroSection/assets/natgeo.png';
const ZDF_LOGO = 'https://res.cloudinary.com/dlcacck3a/image/upload/e_negate/v1769001699/socialbnb/zdf.png';

const MEDIA_LINKS = {
  zdf: 'https://www.zdf.de/gesellschaft/plan-b/plan-b-da-geht-was-deutschland-108.html',
  natgeo:
    'https://www.nationalgeographic.de/reise-und-abenteuer/2024/10/wie-man-mit-einer-reise-in-den-amazonas-den-regenwald-schuetzen-kann',
};
const DNP_LOGO_DE =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082960/socialbnb/containers/OldSTLandingPage/sections/HeroSection/assets/dnp-de.webp';
const DNP_LOGO_EN =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082960/socialbnb/containers/OldSTLandingPage/sections/HeroSection/assets/dnp-en.webp';

const ContactHelp = () => {
  const { lang } = useParams();

  const handleScrollTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.body.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={css.wrapper} data-elbaction="visible:vis contactSection">
      <div className={css.trustBar}>
        <div className={css.trustInner}>
          <span className={css.trustLabel}>
            <FormattedMessage id="ContactHelp.trustBarTitle" />
          </span>
          <span className={css.trustSep} aria-hidden="true">
            |
          </span>
          <a
            href="https://www.trustpilot.com/review/socialbnb.de"
            target="_blank"
            rel="noopener noreferrer"
            className={css.trustMediaLink}
          >
            <span className={css.trustpilotBlock}>
              <img
                src={TRUSTPILOT_RATING}
                alt="Trustpilot star rating"
                className={css.trustLogoRating}
                loading="lazy"
              />
              <span className={css.trustpilotRatingText}>
                <FormattedMessage id="footer.truspilotRating" />
              </span>
            </span>
          </a>
          <span className={css.trustDot} aria-hidden="true">
            ·
          </span>
          <a
            href="https://unternehmen.nachhaltigkeitspreis.de/touristik"
            target="_blank"
            rel="noopener noreferrer"
            className={css.trustMediaLink}
          >
            <span className={css.trustAward}>
              <img
                src={lang === 'de' ? DNP_LOGO_DE : DNP_LOGO_EN}
                alt=""
                className={css.trustLogoAward}
                loading="lazy"
              />
              <span className={css.trustAwardText}>
                <FormattedMessage id="ContactHelp.trustAward" />
              </span>
            </span>
          </a>
          <span className={css.trustDot} aria-hidden="true">
            ·
          </span>
          <span className={css.trustMedia}>
            <a
              href={MEDIA_LINKS.zdf}
              target="_blank"
              rel="noopener noreferrer"
              className={css.trustMediaLink}
            >
              <img src={ZDF_LOGO} alt="ZDF" className={css.trustLogoMedia} loading="lazy" />
            </a>
            <a
              href={MEDIA_LINKS.natgeo}
              target="_blank"
              rel="noopener noreferrer"
              className={css.trustMediaLink}
            >
              <img
                src={NATGEO_LOGO}
                alt="National Geographic"
                className={css.trustLogoNatGeo}
                loading="lazy"
              />
            </a>
          </span>
        </div>
      </div>

      <div className={css.contactSection}>
        <div className={css.contactCard}>
          <div className={css.contactIntro}>
            <picture className={css.avatarPicture}>
              <source media="(min-width: 768px)" srcSet={ALEX_AVATAR_DESKTOP} />
              <img
                className={css.avatar}
                src={ALEX_AVATAR_MOBILE}
                alt=""
                width={46}
                height={46}
                loading="lazy"
                decoding="async"
              />
            </picture>
            <div>
              <div className={css.contactTitle}>
                <FormattedMessage id="ListingPage.contactSectionTitle" />
              </div>
              <div className={css.contactSubtitle}>
                <FormattedMessage id="BookingPanel.contactSubtitle" />
              </div>
            </div>
          </div>

          <div className={css.actions}>
            <a
              href={`tel:${PHONE_NUMBER}`}
              className={css.actionBtn}
              data-elbaction="click:click contactPhoneBtn"
            >
              <PhoneIcon className={css.btnIcon} size={18} />
              <span className={css.btnLabel}>
                <span className={css.phoneDesktop}>{PHONE_DISPLAY}</span>
                <span className={css.phoneMobile}>
                  <FormattedMessage id="ContactHelp.callShortLabel" values={{ phone: PHONE_DISPLAY }} />
                </span>
              </span>
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className={css.actionBtn}
              data-elbaction="click:click contactWhatsappBtn"
            >
              <WhatsAppIcon className={css.btnIcon} size={18} />
              <span className={css.btnLabel}>WhatsApp</span>
            </a>
            <a
              href={`mailto:${EMAIL}`}
              className={css.actionBtn}
              data-elbaction="click:click contactEmailBtn"
            >
              <EmailIcon className={css.btnIcon} size={18} />
              <span className={css.btnLabel}>
                <FormattedMessage id="ContactHelp.messageLabel" />
              </span>
            </a>
            <button
              type="button"
              className={css.scrollTopBtnDesktop}
              onClick={handleScrollTop}
              data-elbaction="click:clicked listBackToTop"
            >
              <ArrowUpIcon className={css.btnIconLight} size={17} />
              <span className={css.btnLabel}>
                <FormattedMessage id="ListingPage.scrollTop" />
              </span>
            </button>
          </div>
        </div>
        <button
          type="button"
          className={css.scrollTopBtnMobile}
          onClick={handleScrollTop}
          data-elbaction="click:clicked listBackToTopMobile"
        >
          <ArrowUpIcon className={css.btnIcon} size={17} />
          <span className={css.btnLabel}>
            <FormattedMessage id="ListingPage.scrollTop" />
          </span>
        </button>
      </div>
    </div>
  );
};

export default ContactHelp;
